import { render, staticRenderFns } from "./AddPeopleModal.vue?vue&type=template&id=6c29c8c4"
import script from "./AddPeopleModal.vue?vue&type=script&lang=js"
export * from "./AddPeopleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports